import { render, staticRenderFns } from "./NormalSearchNav173.vue?vue&type=template&id=87e8a59a&scoped=true"
import script from "./NormalSearchNav173.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav173.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e8a59a",
  null
  
)

export default component.exports